/**
 * SH-503: Newsletter Popup Component
 * Gestisce l'apertura e chiusura del popup newsletter con controllo frequenza
 */
(function() {
  'use strict';

  // Trova il popup e leggi i valori dai data attributes
  const popupElement = document.querySelector('[data-newsletter-popup]');
  if (!popupElement) {
    return;
  }

  // Leggi i valori dai data attributes
  const enablePopup = popupElement.dataset.enable === 'true';
  const delaySeconds = parseInt(popupElement.dataset.delay) || 4;
  const frequencyDays = parseInt(popupElement.dataset.frequency) || 7;

  console.log('Newsletter popup script caricato', { enablePopup, delaySeconds, frequencyDays });

  if (!enablePopup) {
    console.log('Newsletter popup: disabilitato nelle impostazioni');
    return;
  }
  
  // Per test: resetta il localStorage aggiungendo ?reset_newsletter_popup alla URL
  if (window.location.search.includes('reset_newsletter_popup')) {
    try {
      localStorage.removeItem('newsletter_popup_closed_until');
      console.log('Newsletter popup: localStorage resettato');
    } catch (e) {
      console.error('Newsletter popup: errore nel reset localStorage', e);
    }
  }

  let popup = popupElement;
  let overlay = null;
  let closeButtons = [];
  let previousFocus = null;
  const STORAGE_KEY = 'newsletter_popup_closed_until';

  // Path esclusi dal popup
  const excludedPaths = [
    '/pages/iscrizione-newsletter-qb24',
    '/cart',
    '/account',
    '/checkout'
  ];

  function isExcludedPath() {
    const currentPath = window.location.pathname;
    return excludedPaths.some(path => currentPath.includes(path));
  }

  function isPopupClosed() {
    try {
      const closedUntil = localStorage.getItem(STORAGE_KEY);
      if (!closedUntil) return false;
      
      const closedUntilDate = new Date(closedUntil);
      const now = new Date();
      
      return closedUntilDate > now;
    } catch (e) {
      console.error('Error checking localStorage:', e);
      return false;
    }
  }

  function setPopupClosed() {
    try {
      const now = new Date();
      const closedUntil = new Date(now.getTime() + (frequencyDays * 24 * 60 * 60 * 1000));
      localStorage.setItem(STORAGE_KEY, closedUntil.toISOString());
    } catch (e) {
      console.error('Error setting localStorage:', e);
    }
  }

  function handleEscape(event) {
    if (event.key === 'Escape' && popup && !popup.hasAttribute('hidden')) {
      closePopup();
    }
  }

  function openPopup() {
    if (!popup) {
      console.warn('Newsletter popup: popup non trovato');
      return;
    }

    // Verifica se è già chiuso
    if (isPopupClosed()) {
      console.log('Newsletter popup: già chiuso, non mostro');
      return;
    }

    // Verifica path esclusi
    if (isExcludedPath()) {
      console.log('Newsletter popup: path escluso, non mostro');
      return;
    }
    
    console.log('Newsletter popup: apro il popup');

    // Salva il focus corrente
    previousFocus = document.activeElement;

    // Mostra il popup
    popup.removeAttribute('hidden');

    // Blocca lo scroll del body
    document.body.style.overflow = 'hidden';

    // Focus sul primo campo input per accessibilità
    const emailInput = popup.querySelector('input[type="email"]');
    if (emailInput) {
      setTimeout(() => emailInput.focus(), 100);
    }

    // Dispatch evento personalizzato
    popup.dispatchEvent(new CustomEvent('newsletter-popup:open'));
  }

  function closePopup() {
    if (!popup || popup.hasAttribute('hidden')) return;

    // Nascondi il popup
    popup.setAttribute('hidden', '');

    // Ripristina lo scroll del body
    document.body.style.overflow = '';

    // Ripristina il focus precedente
    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus();
    }

    // Salva la chiusura nel localStorage
    setPopupClosed();

    // Dispatch evento personalizzato
    popup.dispatchEvent(new CustomEvent('newsletter-popup:close'));
  }

  function init() {
    if (!popup) {
      console.warn('Newsletter popup: elemento non trovato nel DOM');
      return;
    }
    
    console.log('Newsletter popup: inizializzato', {
      enablePopup,
      delaySeconds,
      frequencyDays,
      isExcluded: isExcludedPath(),
      isClosed: isPopupClosed()
    });

    // Trova overlay e pulsanti di chiusura
    overlay = popup.querySelector('.newsletter-popup-overlay');
    closeButtons = Array.from(popup.querySelectorAll('[data-newsletter-popup-close]'));

    // Aggiungi event listeners per i pulsanti di chiusura
    closeButtons.forEach(button => {
      button.addEventListener('click', closePopup);
    });

    // Chiudi al click sull'overlay
    if (overlay) {
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
          closePopup();
        }
      });
    }

    // Gestisci ESC
    document.addEventListener('keydown', handleEscape);

    // Chiudi popup quando il form viene inviato
    // Il form newsletter fa un redirect, quindi chiudiamo il popup al submit
    const form = popup.querySelector('form');
    if (form) {
      form.addEventListener('submit', function(e) {
        // Chiudi il popup quando il form viene inviato
        // Il form farà un redirect con customer_posted=true
        setTimeout(() => {
          closePopup();
        }, 500); // Piccolo delay per permettere al form di essere inviato
      });
    }

    // Apri il popup dopo il delay
    setTimeout(() => {
      openPopup();
    }, delaySeconds * 1000);
  }

  // Inizializza quando il DOM è pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
